import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { SearchActivityEvents } from 'generated/graphql';

import {
  activityEventExpantionStateSelector, ActivityEventItemExpansionState,
  setActivityItemExpansionState
} from '../../../_state/activity-event-expansion.state';
import { ACTIVITY_EVENT_NAMES } from 'app/activity/helpers/activity-event-names';

@Component({
  selector: 'app-follow-up-event',
  templateUrl: './follow-up-event.component.html'
})

export class ASFollowUpEventComponent extends WithDisposableSubject() implements OnInit {

  EVENT_NAMES = ACTIVITY_EVENT_NAMES;
  @Input() item: SearchActivityEvents.Node;

  showFullText = false;

  /**
   *
   */
  constructor(
    private store: Store<ActivityEventItemExpansionState>
  ) {
    super();
  }

  ngOnInit() {
    this.store.select(
      activityEventExpantionStateSelector({ itemId: this.item.id })
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe(
      (showFullText) => {
        this.showFullText = showFullText;
      });
  }

  setShowFullText(value: boolean) {
    this.store.dispatch(
      setActivityItemExpansionState({
        itemId: this.item.id,
        expanded: value
      })
    );
  }

}
